import { useStepsLogin } from "./Context.login";
export const GoBack = () => {
    const showInit = useStepsLogin.getState().showInit;
    showInit();
};
